<template>
    <div v-if="showForm">
        <b-form @submit.prevent="onSubmit">
            <div class="row">
                <div class="col-md-12">
                    <b-form-group
                        label="Cégnév *"
                        label-for="company_name"
                        :state="customOfferForm.errors.state('company_name')"
                        :invalid-feedback="
                            customOfferForm.errors.get('company_name')
                        "
                    >
                        <b-form-input
                            id="company_name"
                            v-model="customOfferForm.data.company_name"
                            :state="
                                customOfferForm.errors.state('company_name')
                            "
                        />
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group
                        label="Vezetéknév"
                        label-for="surname"
                        :state="customOfferForm.errors.state('surname')"
                        :invalid-feedback="
                            customOfferForm.errors.get('surname')
                        "
                    >
                        <b-form-input
                            id="surname"
                            v-model="customOfferForm.data.surname"
                            :state="customOfferForm.errors.state('surname')"
                        />
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group
                        label="Keresztnév"
                        label-for="forename"
                        :state="customOfferForm.errors.state('forename')"
                        :invalid-feedback="
                            customOfferForm.errors.get('forename')
                        "
                    >
                        <b-form-input
                            id="name"
                            v-model="customOfferForm.data.forename"
                            :state="customOfferForm.errors.state('forename')"
                        />
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group
                        label="Email *"
                        label-for="email"
                        :state="customOfferForm.errors.state('email')"
                        :invalid-feedback="customOfferForm.errors.get('email')"
                    >
                        <b-form-input
                            id="email"
                            v-model="customOfferForm.data.email"
                            type="email"
                            :state="customOfferForm.errors.state('email')"
                        />
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group
                        label="Mobil telefonszám"
                        label-for="phone"
                        :state="customOfferForm.errors.state('phone')"
                        :invalid-feedback="customOfferForm.errors.get('phone')"
                    >
                        <b-input-group prepend="+36">
                            <b-form-input
                                id="phone"
                                v-model="customOfferForm.data.phone"
                                type="text"
                                v-mask="'(##) ### ####'"
                                :state="customOfferForm.errors.state('phone')"
                            />
                        </b-input-group>
                    </b-form-group>
                </div>
            </div>

            <b-form-group
                label="Üzenet"
                label-for="message"
                :state="customOfferForm.errors.state('message')"
                :invalid-feedback="customOfferForm.errors.get('message')"
            >
                <b-form-textarea
                    id="message"
                    v-model="customOfferForm.data.message"
                    :state="customOfferForm.errors.state('message')"
                    no-resize
                    :rows="2"
                />
            </b-form-group>

            <p>
                <small
                    >A küldés gomb megnyomásával elfogadom az Általános
                    Szerződési Feltételeket és az Adatvédelmi
                    nyilatkozatot.</small
                >
            </p>
            <button
                type="submit"
                class="btn mt-3 btn btn-success btn-lg btn-block btn-secondary"
            >
                <i class="fas fa-paper-plane mr-2"></i>ELKÜLD
            </button>
        </b-form>
    </div>
</template>

<script>
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import VueForm from "~/form/form";
import { trackFormSubmission } from "../services/trackingService";
import { submitToMiniCrm } from "../services/miniCrmService";

@Component
export default class FooterForm extends Vue {
    @Prop(String) thankYouUrl;

    email = "";
    saved = false;
    sent = false;
    wegotit = false;
    showForm = true;

    customOfferForm = new VueForm({
        surname: null,
        forename: null,
        company_name: null,
        email: null,
        phone: null,
        email_confirmation: null,
        message: null,
        tax_number: null,
        terms: 1,
        newsletter: 1,
        offer_id: null,
        current_url: window.location.href
    });

    mounted() {
        if (this.thankYouUrl == location.href) {
            this.showForm = false;
        }
        //this.customOfferForm.data.offer_id = this.lead.id;
        this.customOfferForm.data.current_url = window.location.href;
    }

    async onSubmit() {
        try {
            const lead = await this.customOfferForm.post(
                "/hu/regisztracio/egyediajanlat"
            );

            // Run tracking and MiniCRM submission in parallel with error handling
            const [trackingResult, miniCrmResult] = await Promise.allSettled([
                trackFormSubmission(
                    "footer-contact",
                    this.customOfferForm.data,
                    {
                        marketing: true,
                        transactionId: `footer-form-${Date.now()}`,
                        userDataConsent: true
                    }
                ),
                submitToMiniCrm(
                    "footer-contact",
                    {
                        company_name: this.customOfferForm.data.company_name,
                        first_name: this.customOfferForm.data.forename,
                        last_name: this.customOfferForm.data.surname,
                        email: this.customOfferForm.data.email,
                        phone: this.customOfferForm.data.phone,
                        message: this.customOfferForm.data.message,
                        gdpr: this.customOfferForm.data.terms
                    }
                )
            ]);

            // Only navigate after both tracking and MiniCRM submission are complete
            location.href = "/hu/koszonjuk-ajanlatkeresed";
        } catch (error) {
            console.error("Error submitting form:", error);
        }
    }
}
</script>
<style></style>
